import { LISTAR_GRUPOS_CAPTURA, LISTAR_GRUPO_CAPTURA_SELECIONADO } from './mutation-types'

export default {
  [LISTAR_GRUPOS_CAPTURA]: (state, gruposCaptura) => {
    state.gruposCaptura = gruposCaptura
  },
  [LISTAR_GRUPO_CAPTURA_SELECIONADO]: (state, grupoCaptura) => {
    state.grupoCapturaSelecionado = grupoCaptura
  },
}
